import * as React from "react";
import { forwardRef } from "react";
const SvgExpandIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 11, viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 2L10 9L2 2", stroke: "#668987", strokeWidth: 2.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgExpandIcon);
export { ForwardRef as ReactComponent };
